  require('bootstrap');
  global.$ = global.jQuery = $;
  require('lazysizes/plugins/bgset/ls.bgset.js');
  require('lazysizes/lazysizes.js');
  require('script-loader!owl.carousel');
  require('script-loader!slick-carousel');
  require('script-loader!trumbowyg');
  require('trumbowyg/dist/langs/fr.min.js');